export function parseToMs (value) {
  if (value == null || value === '') return null
  const d = value instanceof Date ? value : new Date(value)
  const t = d.getTime()
  return Number.isNaN(t) ? null : t
}

export function formatRemainingCountdown (remainingMs) {
  const totalMinutes = Math.ceil(remainingMs / 60000)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return `${hours}h ${String(minutes).padStart(2, '0')}min`
}

export function getBaselineRemainingMs (deadlineMs, anchorNow) {
  if (deadlineMs == null) return null
  return Math.max(0, deadlineMs - anchorNow)
}

export function computeRemainingPercent (now, deadlineMs, openingMs) {
  if (now >= deadlineMs) return 0

  if (openingMs != null && deadlineMs > openingMs) {
    const totalMs = deadlineMs - openingMs
    const remainingMs = deadlineMs - now
    return Math.min(100, Math.max(0, (remainingMs / totalMs) * 100))
  }

  return 100
}

export function computeProgressValue ({ now, deadlineMs, openingMs, baselineRemainingMs }) {
  const remainingMs = Math.max(0, deadlineMs - now)
  const isExpired = now >= deadlineMs

  if (isExpired) {
    return 0
  }

  if (openingMs != null && deadlineMs > openingMs) {
    const totalMs = deadlineMs - openingMs
    return Math.min(100, Math.max(0, (remainingMs / totalMs) * 100))
  }

  if (baselineRemainingMs != null && baselineRemainingMs > 0) {
    return Math.min(100, Math.max(0, (remainingMs / baselineRemainingMs) * 100))
  }

  return 100
}

export function getSlaProgressBarColor (remainingPercent) {
  if (remainingPercent <= 0) return '#FC4E69'
  if (remainingPercent < 30) return '#EF4444'
  if (remainingPercent < 70) return '#EAB308'
  return '#22C55E'
}

export function getSlaCountdownTextColor (remainingPercent) {
  if (remainingPercent <= 0) return '#FC4E69'
  if (remainingPercent < 30) return '#EF4444'
  if (remainingPercent < 70) return '#EAB308'
  return '#22C55E'
}
